// extracted by mini-css-extract-plugin
export var completionBody = "_lr-2";
export var completionCard = "_lr-0";
export var completionFooter = "_lr-3";
export var completionTitle = "_lr-1";